<app-page-breadcrumb pageTitle="Empresas"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Compact Controls Section -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <!-- Left side - Owner filter toggle -->
    <div class="flex items-center gap-1.5">
      <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
        <button
          type="button"
          (click)="setOwnerFilter('all')"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="filtroOwner === 'all'
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Todos
        </button>
        <button
          type="button"
          (click)="setOwnerFilter('mine')"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="filtroOwner === 'mine'
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Mis empresas
        </button>
      </div>
    </div>

    <!-- Right side - Action buttons -->
    <div class="flex items-center gap-1.5">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button
        type="button"
        (click)="vistaTablero()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"></path>
        </svg>
        Kanban
      </button>
      @if (canImportExport) {
        <button
          type="button"
          (click)="abrirImportExport()"
          title="Importar / exportar CSV de empresas"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12"></path>
          </svg>
          Importar / Exportar
        </button>
      }
      <button
        type="button"
        *appHasPermission="'companies:create'"
        (click)="nuevaEmpresa()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo
      </button>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      <!-- Búsqueda por nombre -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar por nombre comercial
        </label>
        <input
          type="text"
          [(ngModel)]="filtroNombre"
          (ngModelChange)="buscar()"
          placeholder="Nombre de la empresa..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <!-- Búsqueda por contacto -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar por contacto
        </label>
        <input
          type="text"
          [(ngModel)]="filtroContacto"
          (ngModelChange)="buscar()"
          placeholder="Nombre o email del contacto..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <!-- Filtro Tipo de Relación -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Tipo de Relación
        </label>
        <select
          [(ngModel)]="filtroRelationshipType"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (type of relationshipTypes; track type.id) {
          <option [ngValue]="type.id">{{ type.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Tamaño -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Tamaño
        </label>
        <select
          [(ngModel)]="filtroSize"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (size of companySizes; track size.id) {
          <option [ngValue]="size.id">{{ size.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Sector -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Sector
        </label>
        <select
          [(ngModel)]="filtroSector"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (sector of companySectors; track sector.id) {
          <option [ngValue]="sector.id">{{ sector.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Estado -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Estado Lead
        </label>
        <select
          [(ngModel)]="filtroStateLead"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (stateLead of companyStateLeads; track stateLead.id) {
          <option [ngValue]="stateLead.id">{{ stateLead.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Ciclo -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Ciclo
        </label>
        <select
          [(ngModel)]="filtroCycle"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos los ciclos</option>
          @for (cycle of companyCycles; track cycle.id) {
          <option [ngValue]="cycle.id">{{ cycle.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro País (por prefijo telefónico) -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          País
        </label>
        <app-country-select
          [countries]="filterCountries"
          [value]="filtroPais"
          [clearable]="true"
          placeholder="Todos"
          (valueChange)="onCountryFilterChange($event)" />
      </div>

      <!-- Botón Limpiar Filtros -->
      <div class="flex items-end">
        <button
          type="button"
          (click)="limpiarFiltro()"
          class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando empresas...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Tabla de empresas -->
  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <!-- Table Header -->
        <!-- inc38 — sin las columnas Tipo de Relación, Tamaño y Sector: sus valores
             son largos y desplazaban al resto. Siguen disponibles como filtros arriba,
             en la vista Kanban y en el detalle de la empresa. -->
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre Comercial</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Razón Social</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Contacto Principal</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Teléfono</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tipo de Identif. Tributaria</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Código Fiscal</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Ciclo</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (empresas.length === 0) {
          <tr>
            <td colspan="9" class="px-5 py-8 text-center">
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
                  </path>
                </svg>
                <span>No hay empresas registradas</span>
              </div>
            </td>
          </tr>
          }

          @for (empresa of empresas; track empresa.id) {
          <tr>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="block font-medium text-gray-800 dark:text-white/90">
                {{ empresa.commercialName }}
              </span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ empresa.businessName || '-' }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="block max-w-[180px] truncate" [title]="empresa.primaryContactName || ''">
                {{ empresa.primaryContactName || '—' }}
              </span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="inline-flex items-center gap-2">
                @if (countryFlagCode(empresa.phone); as cc) {
                  <span class="fi fi-{{ cc }} rounded-sm shrink-0" [title]="countryName(empresa.phone)"></span>
                }
                <span>{{ empresa.phone || '-' }}</span>
              </span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ empresa.companyTaxTypeName || '—' }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ empresa.taxCode || '-' }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              @if (empresa.idCompanyStateLead) {
                <app-badge [color]="'primary'">
                  {{ empresa.companyStateLeadName || getStateLeadName(empresa.idCompanyStateLead) }}
                </app-badge>
              } @else {
                <span>-</span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              @if (empresa.idCompanyCycle) {
                <app-badge [color]="'light'">
                  {{ empresa.companyCycleName || getCycleName(empresa.idCompanyCycle) }}
                </app-badge>
              } @else {
                <span>-</span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
              <div class="flex items-center justify-center gap-2">
                <button (click)="viewDetail(empresa)"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                  title="Ver">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                    </path>
                  </svg>
                </button>
                <button (click)="editarEmpresa(empresa)"
                  *appHasPermission="'companies:edit'"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                  title="Editar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                    </path>
                  </svg>
                </button>
                <button (click)="eliminarEmpresa(empresa)"
                  *appHasPermission="'companies:delete'"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                  title="Eliminar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                    </path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    @if (globalTotalPages >= 1) {
    <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ globalTotalElements }} registros</span>
          <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                   focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (opt of PAGE_SIZE_OPTIONS; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Anterior
          </button>
          <div class="flex items-center gap-1.5">
            <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
            <select [ngModel]="pageDisplay" (ngModelChange)="cambiarPagina($event - 1)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                     bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                     focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              @for (p of pagesArray; track p) {
                <option [value]="p">{{ p }}</option>
              }
            </select>
            <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
          </div>
          <button type="button" (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>

<!-- Modal de Detalle -->
<app-empresa-detail-modal
  [isOpen]="showDetailModal"
  [company]="selectedCompany"
  [relationshipTypes]="relationshipTypes"
  [sizes]="companySizes"
  [sectors]="companySectors"
  [taxTypes]="taxTypes"
  [stateLeads]="companyStateLeads"
  [cycles]="companyCycles"
  (close)="closeDetailModal()"
/>

<!-- Modal Importar / Exportar (permiso granular por pestaña) -->
<app-import-export-modal
  [isOpen]="showImportExportModal"
  initialTab="companies"
  (close)="cerrarImportExport()">
</app-import-export-modal>
